import React, { ReactNode, FC } from 'react';
import RateLimitExceeded from 'src/templates/RateLimitExceeded';

interface ThrottleProps {
  isRateLimited: boolean;
  children: ReactNode;
}

export const ReservationFlowWithThrottle: FC<ThrottleProps> = ({
  isRateLimited,
  children,
}) => {
  if (isRateLimited) {
    return <RateLimitExceeded />;
  }
  return <>{children}</>;
};
